<script lang="ts">
  import Anchor from "src/partials/Anchor.svelte"
</script>

<div class="pointer-events-none -ml-12 mt-8 mb-4 flex justify-center">
  <Anchor theme="button">See more</Anchor>
</div>
